import { PatientSession } from './PatientSession';

/**
 * Module-level reference to the currently active {@link PatientSession}.
 *
 * This accessor exists so that non-React code (engine tools, action classes)
 * can reach the session without being injected through the full React tree.
 * Set via {@link setActiveSession} from {@link PatientSessionProvider} and
 * cleared on teardown so stale references are never used.
 */
let active: PatientSession | null = null;

/**
 * Called by {@link PatientSessionProvider} when a session becomes active or
 * is torn down. Must not be called from any other site.
 */
export function setActiveSession(s: PatientSession | null): void {
    active = s;
}

/**
 * Returns the currently active {@link PatientSession}, or {@code null} if no
 * patient is loaded. Engine tools use this to reach {@link ContourService}
 * without requiring DI through {@link ToolManager}.
 */
export function getActiveSession(): PatientSession | null {
    return active;
}
